import React, { HTMLAttributes } from 'react';

const colors: Record<string, string> = {
  blue: 'bg-blue',
  gray: 'bg-gray-300',
  purple: 'bg-purple',
  yellow: 'bg-yellow',
};

const variants: Record<string, string> = {
  blob: 'rounded-full h-2.5 bg-yellow max-w-[244px]',
  thin: 'h-px',
};

type HorizontalSeparatorProps = {
  color?: keyof typeof colors;
  variant?: keyof typeof variants;
  className?: string;
} & HTMLAttributes<HTMLHRElement>;

const HorizontalSeparator: React.FC<HorizontalSeparatorProps> = ({
  color = 'gray',
  variant = 'thin',
  className = '',
  ...props
}) => {
  return (
    <hr
      {...props}
      className={`border-0 ${variants[variant]} ${colors[color]} ${className}`}
    />
  );
};

export default HorizontalSeparator;
